import http from "../axios/http-common";

class InterfaceSpri {
  getSpri(reg) {
    return http.getData(`/register/${reg}/spri`);
  }
  saveSpri(
    register_id,
    tanggal,
    keluhan_utama,
    riwayat_penyakit,
    pemeriksaan_fisik,
    pemeriksaan_penunjang,
    diagnosis,
    terapi,
    dokter_id,
    author_id,
    unit_id
  ) {
    return http.postData(`/spri`, {
      register_id: register_id,
      tanggal: tanggal,
      keluhan_utama: keluhan_utama,
      riwayat_penyakit: riwayat_penyakit,
      pemeriksaan_fisik: pemeriksaan_fisik,
      pemeriksaan_penunjang: pemeriksaan_penunjang,
      diagnosis: diagnosis,
      terapi: terapi,
      dokter_id: dokter_id,
      author_id: author_id,
      unit_id: unit_id
    });
  }
  editSpri(
    id,
    register_id,
    tanggal,
    keluhan_utama,
    riwayat_penyakit,
    pemeriksaan_fisik,
    pemeriksaan_penunjang,
    diagnosis,
    terapi,
    dokter_id,
    author_id,
    unit_id
  ) {
    return http.putData(`/spri/${id}`, {
      register_id: register_id,
      tanggal: tanggal,
      keluhan_utama: keluhan_utama,
      riwayat_penyakit: riwayat_penyakit,
      pemeriksaan_fisik: pemeriksaan_fisik,
      pemeriksaan_penunjang: pemeriksaan_penunjang,
      diagnosis: diagnosis,
      terapi: terapi,
      dokter_id: dokter_id,
      author_id: author_id,
      unit_id: unit_id
    });
  }
  saveTtdSpri(idSpri, user_id, password) {
    return http.postData(`/spri/${idSpri}/signature`, {
      dokter_id: user_id,
      password: password

    })
  }
}

export default new InterfaceSpri();
